import React from 'react';
import { Users } from '../..';
import { Navigation } from '../../../utils/navigation';

export const HO_Manager_Users = (props) => (
  <Users title='Users' Navigation={Navigation()} addNewBtnTitle='Add New User' managedRole='User' {...props} />
);
